<template>
  <div class="bg-neutral-100">
    <div class="container">
      <LazyProductDetails :data="data.shopProduct" />
      <LazySectionRelatedShopProductsList
        :data="relatedArticlesData"
        :index="2"
      ></LazySectionRelatedShopProductsList>
    </div>
  </div>
</template>

<script setup lang="ts">
import { toHead } from 'vue-datocms'
import { useAppStore } from '~/stores/AppStore'
import { ModelApiKey } from '~/types/models'
import type { StringMultiLocaleField, BooleanTypeMultiLocaleField } from '~/types/generated'

const { locale } = useI18n()
const route = useRoute()
const store = useAppStore()

const { throwError } = useNuxtError()
const config = useRuntimeConfig()

const { data, error } = await useAsyncGql('shopProduct', {
  locale: locale.value,
  slug: route.params.slug as string,
  options: {
    initialCache: false
  }
})

if (!data?.value!.shopProduct || error.value) {
  throwError(404)
}

if (data?.value!.shopProduct) {
  route.meta.nuxtI18n = useLocaleSlugs(
    data.value.shopProduct._allSlugLocales as StringMultiLocaleField[],
    data.value.shopProduct._allPublishTranslationLocales as BooleanTypeMultiLocaleField[]
  )
}

const datoHead = toHead((data.value as any).shopProduct.seo)
const i18nHeadLinks = useLocaleHeadLinks(ModelApiKey.ShopProduct)

const relatedArticlesData = {
  __typename: 'SectionRelatedShopProductsListRecord',
  title: ''
}

useHead(() => {
  const metaTags = [...(datoHead.meta || [])]

  // Check for noindex
  if ((data.value as any).shopProduct.noIndex) {
    metaTags.push({ name: 'robots', hid: 'robots', content: 'noindex' })
  }

  return {
    title: datoHead.title,
    link: [...i18nHeadLinks],
    meta: [
      {
        hid: 'og:url',
        property: 'og:url',
        content: config.public.appUrl + route.fullPath
      },
      ...metaTags
    ]
  }
})

onMounted(() => {
  store.setTheme('white')
})
</script>
